// extracted by mini-css-extract-plugin
var _1 = "styles_noOrders__Luzuv";
export { _1 as "noOrders" }
